import React from "react";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import ArrowForwardIcon from "@mui/icons-material/ArrowForward";
import ArrowBackIosIcon from '@mui/icons-material/ArrowBackIos';

const PlantillaScreen2 = ({
    titulo,
    children,
    className,
    className_main = 0,
}) => {
    return (
        <div
            className={`${className_main === 0
                ? "plantilla-screen"
                : className_main === 2
                    ? "plantilla-screen-solicitud"
                    : "plantilla-screen-analisis"
                } ${className === undefined || className === null ? "" : className}`}
        >
            <div className="plantilla-screen-titulo">
                <div className="plantilla-screen-header">
                    <div className="plantilla-screen-header-titulo">{titulo}</div>
                </div>
                <div className="plantilla-screen-efecto">
                    <div className="plantilla-screen-efecto-bl"></div>
                    <div className="plantilla-screen-efecto-circle"></div>
                    <div className="plantilla-screen-efecto-br"></div>
                </div>
            </div>
            <div className="">{children}</div>
        </div>
    );
};

export default PlantillaScreen2;
